export class Sorting {
    sortBy;
    direction;

    constructor(obj) {
        this.sortBy = obj && obj.sortBy || null;
        this.direction = obj && obj.direction || SortingDirection.ASC;
    }

    static createSorting(obj) {
        return new Sorting(obj);
    }
}

export const SortingDirection = {
    ASC: 'ASC',
    DESC: 'DESC'
};

export function toggleDirection(direction) {
    let result;
    if (!direction) {
        result = SortingDirection.ASC;
    }
    else if (direction === SortingDirection.ASC) {
        result = SortingDirection.DESC;
    }
    else {
        result = SortingDirection.ASC;
    }
    return result;
}

export const DefaultSorting = Sorting.createSorting();


// WEBPACK FOOTER //
// ./src/store/modules/page/Sorting.js